import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PromoSlider from '../../containers/promo-slider';
import Promo from '../../containers/promo';

const PromoSliderBlock = props => <PromoSlider {...props} />;
PromoSliderBlock.displayName = 'PromoSlider';

export default withDynamicComponents({
  componentWhitelist: [
    Promo
  ],
  mapInputToOutput: [
    ['components', 'children'],
  ],
})(PromoSliderBlock);



// WEBPACK FOOTER //
// ./src/blocks/promo-slider/index.jsx